export default __webpack_public_path__ + "static/media/8.f598a07b.png";